export default require('./app.json');